import React from 'react';
import { List, ListItem, ListItemText, Theme } from '@mui/material';
import { isSameDay } from 'date-fns';
import { DateRange, DefinedRange } from './types';

type DefinedRangesProps = {
    setRange: (range: DateRange) => void;
    selectedRange: DateRange;
    ranges: DefinedRange[];
    defaultColor?: string;
    selectedColor?: string;
    defaultBgColor?: string;
    selectedBgColor?: string;
};

const isSameRange = (first: DateRange, second: DateRange) => {
    const { startDate: fStart, endDate: fEnd } = first;
    const { startDate: sStart, endDate: sEnd } = second;
    if (fStart && sStart && fEnd && sEnd) {
        return isSameDay(fStart, sStart) && isSameDay(fEnd, sEnd);
    }
    return false;
};

export const DefinedRanges: React.FunctionComponent<DefinedRangesProps> = function ({
    ranges,
    setRange,
    selectedRange,
    defaultColor,
    defaultBgColor,
    selectedColor,
    selectedBgColor,
}: DefinedRangesProps) {
    const defaultStyle = {
        backgroundColor: defaultBgColor || null,
        color: defaultColor || null,
    };
    const selectedStyle = {
        backgroundColor: (theme: Theme) => selectedBgColor || theme.palette.primary.dark,
        color: selectedColor || 'primary.contrastText',
        '&:hover': {
            backgroundColor: (theme: Theme) => selectedBgColor || theme.palette.primary.dark,
        },
    };

    return (
        <List>
            {ranges.map((range) => (
                <ListItem
                    button
                    key={range.label}
                    onClick={() => setRange(range)}
                    sx={isSameRange(range, selectedRange) ? selectedStyle : defaultStyle}
                >
                    <ListItemText
                        primaryTypographyProps={{
                            variant: 'body2',
                            sx: {
                                fontWeight: isSameRange(range, selectedRange) ? 'bold' : 'normal',
                            },
                        }}
                    >
                        {range.label}
                    </ListItemText>
                </ListItem>
            ))}
        </List>
    );
};
